import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

export const formatCurrency = (cents) => {
  return `RM ${(cents / 100).toFixed(2)}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-MY', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('en-MY', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Fallback color if a class row has no `color` from the backend
const CATEGORY_COLOR_FALLBACK = {
  night: '#2563EB',
  personalised: '#1E3A8A',
  community: '#DC2626',
  speed_sprint: '#2563EB', // Friday Night Class is still a Night Class — same blue
  teen: '#7C3AED',
  active_kids: '#FACC15',
  grassroots_kids: '#F97316',
  distance_dev: '#16A34A',
  fitness_dev: '#0D9488'
};

export const classColor = (cls) => {
  if (!cls) return '#A855F7';
  return cls.color || CATEGORY_COLOR_FALLBACK[cls.category] || '#A855F7';
};

// Availability chip: Available (green) / Limited Slots (yellow) / Class Full (red)
export const availabilityStatus = (cls) => {
  if (!cls) return { key: 'unknown', label: '', className: '' };
  const slots = cls.available_slots ?? 0;
  const max = cls.max_students ?? 0;
  if (cls.status === 'cancelled') {
    return { key: 'cancelled', label: 'Cancelled', className: 'bg-red-100 text-red-800 border-red-300' };
  }
  if (slots <= 0) {
    return { key: 'full', label: 'Class Full', className: 'bg-red-100 text-red-800 border-red-300' };
  }
  // Limited when <=25% slots left (or 3 or fewer in absolute terms — whichever hits first)
  if (max > 0 && (slots / max <= 0.25 || slots <= 3)) {
    return { key: 'limited', label: `Limited · ${slots} left`, className: 'bg-yellow-100 text-yellow-900 border-yellow-300' };
  }
  return { key: 'available', label: `Available · ${slots} left`, className: 'bg-emerald-100 text-emerald-800 border-emerald-300' };
};
